/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/336-shift': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M10.5 14h-5a.5.5 0 01-.5-.5V8H3a.5.5 0 01-.354-.854l5-5a.5.5 0 01.707 0l5 5a.499.499 0 01-.354.854h-2v5.5a.5.5 0 01-.5.5zM6 13h4V7.5a.5.5 0 01.5-.5h1.293L8 3.207 4.207 7H5.5a.5.5 0 01.5.5V13z"/>'
  }
})
